import { useQuery } from "react-query";
import { getContentfulRecipes } from "src/services/contentfulClient";

export const useRecipes = () => {
  return useQuery(["contentful", "recipes"], () => getContentfulRecipes());
};
